var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0","padding-left":"8px"}},[_c('el-image',{staticStyle:{"width":"300px","height":"300px"},attrs:{"src":_vm.OSS_PIC_BASE_URL + _vm.info.pic_url,"preview-src-list":_vm.preview_src_list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }